module.exports = __webpack_public_path__ + "img/wind-turbine.8850ebf4.svg";